<template>
  <div>
    <div class="p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "360Competence",
  data() {
    return {
      columns: [
        {
          field: "Name",
          key: "a",
          title: "Employee Name",
          align: "left",
          width: "15%",
          renderBodyCell: ({ row }) => {
            return (
              <div
                on-click={() => this.viewTeamMember()}
                class="flex gap-5 items-center"
              >
                <div class="h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <p>{row.Name}</p>
              </div>
            );
          },
        },
        { field: "Area", key: "b", title: "Competency Area" },
        {
          field: "Percentage",
          key: "c",
          title: "Percentage Given",
        },
        { field: "Feedback", key: "e", title: "Feedback" },
      ],
      tableData: [
        {
          Name: "John Doe",
          Area: "Agility",
          Percentage: "70%",
          Feedback: "",
        },
      ],
    };
  },
};
</script>
